
require('../../static/css/reset.css');
require('../../sass/common/reset.scss');

require('../../common/layout/header/header').run('noLogin');
require('../../common/layout/footer/footer').run();

require('../../sass/common/footer_link_html.scss');

$(document).ready(function(){
    $(".job-item").on("click",function(){
        $(this).siblings().removeClass('current');
        $(this).addClass('current');
        
        $('.blk01').addClass('hidden');
        $('.blk01[data-for="' + $(this).attr('id') + '"]').removeClass('hidden');
    });
    
});


// WEBPACK FOOTER //
// ./src/js/recruit/recruit.js